import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 48px;
  padding: 28px;
  @media (max-width: 600px) {
    margin-top: 32px;
  }
`;

export const Title = styled.div`
  font-weight: bold;
  font-size: 16px;
  line-height: 130%;
  color: #9b43ff;
  text-align: center;
`;

export const Heading = styled.div`
  font-weight: bold;
  font-size: 36px;
  line-height: 120%;
  margin-top: 13px;
  text-align: center;
  @media (max-width: 600px) {
    font-size: 28px;
    margin-top: 8px;
  }
`;

export const CardContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 64px;
  flex-wrap: wrap;
  justify-content: center;
  width: 100%;
  @media (max-width: 600px) {
    margin-top: 48px;
  }
`;

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 360px;
  margin: 0 3%;
  & img {
    width: 100%;
  }
  @media (max-width: 600px) {
    width: 284px;
  }
`;

export const CardImage = styled.div``;

export const CardTitle = styled.div`
  font-weight: bold;
  font-size: 20px;
  line-height: 140%;
  margin-top: 32px;
  text-align: center;
  @media (max-width: 600px) {
    margin-top: 16px;
  }
`;

export const CardDescription = styled.div`
  margin-top: 16px;
  text-align: center;
  font-size: 18px;
  line-height: 130%;
  color: #878d96;
  margin-bottom: 48px;
  @media (max-width: 600px) {
    margin-top: 8px;
    font-size: 14px;
  }
`;
